import React from "react";
import backgroundImg from "../../assets/images/background/contact_us_image.png";
import "./ContactCTA.scss";
import { useNavigate } from "react-router-dom";

const ContactCTA = () => {
    const navigate = useNavigate();

    return (
        <section className="contact-cta" id="contact">
            <div
                className="contact-cta__content"
                style={{ backgroundImage: `url(${backgroundImg})` }}
            >
                <div className="contact-cta__overlay">
                    <h2>
                        If You Like Any Of Our Products <br /> Reach Out To Us.
                    </h2>
                    <button onClick={() => navigate("/contact")}>Let’s talk</button>
                </div>
            </div>
        </section>
    );
};

export default ContactCTA;
